import { forwardRef } from 'react';

import { cx } from '../../utils/cx';
import { Button, type ButtonProps } from '../button/button';

import styles from './empty_state.module.css';

export type EmptyStateActionButtonProps = Omit<ButtonProps, 'className'> & {
  className?: string;
};

/**
 * EmptyStateActionButton - action sub-component for empty states.
 */
export const EmptyStateActionButton = forwardRef<
  HTMLButtonElement,
  EmptyStateActionButtonProps
>(({ className, children, ...rest }, ref) => {
  return (
    <Button
      ref={ref}
      className={cx([styles.action, className])}
      variant="secondary"
      {...rest}
    >
      {children}
    </Button>
  );
});
